/**
 * Editable string control - click to edit inline
 */

import { useState } from 'react';

interface StringControlProps {
  value: string;
  onChange: (value: string) => void;
}

export function StringControl({ value, onChange }: StringControlProps) {
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState('');

  const startEdit = () => {
    setEditValue(value ?? '');
    setEditing(true);
  };

  const saveEdit = () => {
    onChange(editValue);
    setEditing(false);
  };

  const cancelEdit = () => {
    setEditing(false);
  };

  if (editing) {
    return (
      <input
        type="text"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') saveEdit();
          if (e.key === 'Escape') cancelEdit();
        }}
        onBlur={saveEdit}
        autoFocus
        style={{
          width: 100,
          marginLeft: 'auto',
          background: '#374151',
          color: '#e5e7eb',
          border: '1px solid #6b7280',
          borderRadius: 3,
          padding: '2px 4px',
          fontSize: 10,
          fontFamily: 'monospace'
        }}
        className="nodrag"
      />
    );
  }

  return (
    <span
      onClick={startEdit}
      style={{
        color: '#3b82f6',
        fontFamily: 'monospace',
        fontSize: 11,
        marginLeft: 'auto',
        maxWidth: 120,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        padding: '2px 4px',
        borderRadius: 3,
        background: 'rgba(59, 130, 246, 0.1)'
      }}
      title="Click to edit"
    >
      {value || '""'}
    </span>
  );
}
